import React from 'react';
import {
    Badge,
    Box,
    Flex,
    FormControl,
    FormLabel,
    HStack,
    Icon,
    Text,
    Textarea,
    VStack,
    useColorMode,
} from '@chakra-ui/react';
import { AiOutlineFileText, AiOutlineInfoCircle, AiOutlinePaperClip } from 'react-icons/ai';
export const AnexosEmBreve = () => {
    const { colorMode } = useColorMode();
    const fieldBg = colorMode === 'dark' ? 'whiteAlpha.50' : 'blackAlpha.50';

    return (
        <Box
            border="1px dashed"
            borderColor="borderPrimary"
            borderRadius="lg"
            bg={fieldBg}
            px={4}
            py={3}
            aria-disabled="true"
        >
            <Flex align="center" gap={3} wrap="wrap">
                <Flex
                    w="34px"
                    h="34px"
                    borderRadius="lg"
                    bg="surfaceRaised"
                    border="1px solid"
                    borderColor="borderSubtle"
                    align="center"
                    justify="center"
                    flexShrink={0}
                >
                    <Icon as={AiOutlinePaperClip} color="textSecondary" boxSize="17px" />
                </Flex>
                <Box flex="1" minW="180px">
                    <HStack spacing={2} mb={0.5}>
                        <Icon as={AiOutlineFileText} color="textMuted" boxSize="12px" />
                        <Text fontSize="xs" fontWeight="800" color="textPrimary">
                            Arquivos e anexos
                        </Text>
                    </HStack>
                    <Text fontSize="10px" color="textMuted">
                        PDFs, fotos e outros arquivos poderão ser adicionados aqui.
                    </Text>
                </Box>
                <Badge bg="surfaceRaised" color="textSecondary" borderRadius="full" px={2.5} py={1} fontSize="9px" fontWeight="900">
                    Em breve
                </Badge>
            </Flex>
        </Box>
    );
};

const AnotacaoFormSection = ({
    isEditing = false,
    existingValue = '',
    newValue = '',
    onNewValueChange,
    entityLabel = 'registro',
    showSaveShortcut = false,
}) => {
    const { colorMode } = useColorMode();
    const fieldBg = colorMode === 'dark' ? 'whiteAlpha.50' : 'blackAlpha.50';

    return (
        <VStack align="stretch" spacing={4}>
            {isEditing && (
                <FormControl>
                    <FormLabel fontSize="xs" color="textSecondary" textTransform="uppercase" letterSpacing="1px">
                        Observação anterior
                    </FormLabel>
                    <Textarea
                        value={existingValue || ''}
                        isReadOnly
                        placeholder="Nenhuma observação anterior registrada."
                        bg={fieldBg}
                        borderColor="borderPrimary"
                        color="textSecondary"
                        _placeholder={{ color: 'textMuted' }}
                        _focus={{ borderColor: 'borderPrimary', boxShadow: 'none' }}
                        rows={3}
                        resize="vertical"
                        cursor="default"
                        aria-label="Observação anterior, somente leitura"
                    />
                    <HStack spacing={1.5} mt={1.5} align="flex-start">
                        <Icon as={AiOutlineInfoCircle} color="textMuted" boxSize="12px" mt="1px" flexShrink={0} />
                        <Text fontSize="10px" color="textMuted">
                            Somente leitura. O conteúdo já registrado permanece preservado no histórico.
                        </Text>
                    </HStack>
                </FormControl>
            )}

            <FormControl>
                <FormLabel fontSize="xs" color="textSecondary" textTransform="uppercase" letterSpacing="1px">
                    {isEditing ? 'Nova observação' : 'Observação inicial'}
                </FormLabel>
                <Textarea
                    value={newValue}
                    onChange={e => onNewValueChange?.(e.target.value)}
                    placeholder={`Registre uma nova observação sobre este ${entityLabel}...`}
                    bg={fieldBg}
                    borderColor="borderPrimary"
                    color="textPrimary"
                    _placeholder={{ color: 'textMuted' }}
                    _focus={{ borderColor: 'secondary', boxShadow: 'none' }}
                    rows={3}
                    resize="vertical"
                    aria-label={isEditing ? 'Nova observação' : 'Observação inicial'}
                />
                <Flex justify="space-between" gap={3} mt={1.5} wrap="wrap">
                    <Text fontSize="10px" color="textMuted">
                        Ao salvar, será adicionada à linha do tempo da tela Anotações.
                    </Text>
                    {showSaveShortcut && (
                        <Text fontSize="10px" color="textMuted" whiteSpace="nowrap">

                        </Text>
                    )}
                </Flex>
            </FormControl>

            <AnexosEmBreve />
        </VStack>
    );
};

export default AnotacaoFormSection;
